module.exports = __webpack_public_path__ + "72edb693649c36323905281d52390538.png";